import { lazy } from 'react';

const importWidgetAdminView = widgetComponent =>
	lazy(() =>
		import(`components/administration/widgets/${widgetComponent}`).catch(() =>
			import(`components/widgets/NullView`)
		)
	);

export default importWidgetAdminView;